"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingOverlay = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../utils/classFunctions");
require("./index.scss");
const className = 'loading-overlay';
const defaultMessage = (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/LoadingOverlay:LoadingText', defaultMessage: 'Loading...' }));
const LoadingOverlay = (props) => {
    const { isLoading, loadingMessage = defaultMessage, hideLoader, modificators, children } = props;
    const overlayClassName = (0, classFunctions_1.getClassNames)(`${className}__overlay`, modificators);
    return (react_1.default.createElement("div", { className: className },
        children,
        isLoading && (react_1.default.createElement("div", { className: overlayClassName },
            !hideLoader && (react_1.default.createElement("div", { className: `${className}__spinner` })),
            react_1.default.createElement("div", { className: `${className}__text` }, loadingMessage)))));
};
exports.LoadingOverlay = LoadingOverlay;
//# sourceMappingURL=index.js.map